import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { MdDelete } from "react-icons/md";

function RemoveModal({ handleOnRemoveClick }) {
  const [show, setShow] = useState(false);

  const handleOnSave = () => {
    handleOnRemoveClick();
    setShow(false);
  };

  const handleOnClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <Button variant="outline-warning" size="sm" onClick={handleShow}>
        <MdDelete />
      </Button>

      <Modal show={show} onHide={handleOnClose} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>Delete Folder</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete this folder ?{" "}
          <div style={{ color: "red" }}>All files in it will be deleted!</div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleOnSave}>
            DELETE
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default RemoveModal;
